import { gql } from '@apollo/client'

export const CREATE_ONE_NOTE = gql`
  mutation createOneNote($text: String!, $shiurId: String!) {
    createOneNote(text: $text, shiurId: $shiurId) {
      noteId
    }
  }
`
